import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AccountInfoService } from '../../dashboard/accounts/services/account-info.service';
import { AccountTypeService } from '../../dashboard/accounts/services/account-type.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddAccountComponent } from '../add-account/add-account.component';
import { AccountInfo } from '../../models/classes/accounts/account-info';
import { AccountInfoCriteria } from '../../models/search-criterias/account-info-criteria';
import { ResponseState } from '../../models/support/response-state';
import { SharedService } from '../../services/other/shared.service';

@Component({
  selector: 'app-choose-accounts',
  templateUrl: './choose-accounts.component.html',
  styleUrls: ['./choose-accounts.component.scss'],
})
export class ChooseAccountsComponent implements OnInit {
  @Input() name;
  @Input() levelNumber;
  @Input() accountGroupCode;
  @Input() AccountsetupId;
  @Input() supplierData;
  @Input() employeeData;
  @Input() isViewPlus: boolean;

  @Output() emitService = new EventEmitter();
  public freeText;
  public IsActive;
  public ExpandRowLevelTwo: number;
  public ExpandRowLevelThree: number;
  public ExpandRowLevelFour: number;
  public ExpandRowLevelFive: number;
  public ExpandRowLevelSix: number;
  public ExpandRowLevelSeven: number;
  public ExpandRowLevelEight: number;

  public AccountToSend: AccountInfo;
  public AccountToDelete: AccountInfo;
  fromSearch: boolean = false;
  Loading: boolean = false;

  constructor(
    private toastr: ToastrService,
    public sharedService: SharedService,
    public accountInfoService: AccountInfoService,
    public datepipe: DatePipe,
    public accountTypeService: AccountTypeService,
    public translateService: TranslateService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {

    this.GetData(1, null);
  }

  searchByText() {
    this.fromSearch = true;
    this.accountInfos = [];
    this.accountInfos2 = [];
    this.accountInfos3 = [];
    this.accountInfos4 = [];
    this.accountInfos5 = [];
    this.accountInfos6 = [];
    this.accountInfos7 = [];
    this.accountInfos8 = [];
    this.GetData(this.freeText == '' ? 1 : null, 0);
  }
  public accountInfos;
  public accountInfos2;
  public accountInfos3;
  public accountInfos4;
  public accountInfos5;
  public accountInfos6;
  public accountInfos7;
  public accountInfos8;

  GetData(levelNumber: number, ParentId: number) {
    this.Loading = true;
    let criteria = new AccountInfoCriteria();
    if (this.AccountsetupId != undefined) {
      criteria.AccountSetupId = this.AccountsetupId;
    }
    criteria.PageSize = 20;
    criteria.PagingEnabled = levelNumber == 1 ? true : false;
    criteria.PageNumber = 0;
    criteria.FreeText = '';
    criteria.LevelNumber = levelNumber;
    criteria.IsActive = true;
    criteria.ParentId = ParentId;
    criteria.FreeText = !this.fromSearch ? '' : this.freeText;

    this.accountInfoService
      .getAccountInfo(criteria)
      .subscribe((response: any) => {
        if (response.State == ResponseState.Success) {
          if (response.AccountInfos.length > 0) {
            if (response.AccountInfos[0].LevelNumber == 1 || this.fromSearch) {
              this.accountInfos = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 2 && ParentId != 0) {
              this.accountInfos2 = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 3 && ParentId != 0) {
              this.accountInfos3 = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 4 && ParentId != 0) {
              this.accountInfos4 = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 5 && ParentId != 0) {
              this.accountInfos5 = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 6 && ParentId != 0) {
              this.accountInfos6 = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 7 && ParentId != 0) {
              this.accountInfos7 = response.AccountInfos;
            }
            if (response.AccountInfos[0].LevelNumber == 8 && ParentId != 0) {
              this.accountInfos8 = response.AccountInfos;
            }
          } else {
            levelNumber == 2
              ? (this.accountInfos2 = undefined)
              : levelNumber == 3
              ? (this.accountInfos3 = undefined)
              : levelNumber == 4
              ? (this.accountInfos4 = undefined)
              : levelNumber == 5
              ? (this.accountInfos5 = undefined)
              : levelNumber == 6
              ? (this.accountInfos6 = undefined)
              : levelNumber == 7
              ? (this.accountInfos7 = undefined)
              : levelNumber == 8
              ? (this.accountInfos7 = undefined)
              : undefined;
          }
          this.fromSearch = false;
          this.Loading = false;
        }
      });
  }

  ExpandLevelTwo(i, parentId: number) {
    if (this.ExpandRowLevelTwo == undefined || this.ExpandRowLevelTwo != i) {
      this.ExpandRowLevelTwo = i;

      this.GetData(2, parentId);
    } else {
      this.ExpandRowLevelTwo = undefined;
    }
    this.ExpandRowLevelThree = undefined;
    this.ExpandRowLevelFour = undefined;
    this.ExpandRowLevelFive = undefined;
    this.ExpandRowLevelSix = undefined;
    this.ExpandRowLevelSeven = undefined;
    this.ExpandRowLevelEight = undefined;
  }
  ExpandLevelThree(j, parentId: number) {
    if (
      this.ExpandRowLevelThree == undefined ||
      this.ExpandRowLevelThree != j
    ) {
      this.ExpandRowLevelThree = j;
      this.GetData(3, parentId);
    } else {
      this.ExpandRowLevelThree = undefined;
    }

    this.ExpandRowLevelFour = undefined;
    this.ExpandRowLevelFive = undefined;
    this.ExpandRowLevelSix = undefined;
    this.ExpandRowLevelSeven = undefined;
    this.ExpandRowLevelEight = undefined;
  }
  ExpandLevelFour(k, parentId: number) {
    if (this.ExpandRowLevelFour == undefined || this.ExpandRowLevelFour != k) {
      this.ExpandRowLevelFour = k;
      this.GetData(4, parentId);
    } else {
      this.ExpandRowLevelFour = undefined;
    }

    this.ExpandRowLevelFive = undefined;
    this.ExpandRowLevelSix = undefined;
    this.ExpandRowLevelSeven = undefined;
    this.ExpandRowLevelEight = undefined;
  }
  ExpandLevelFive(r, parentId: number) {
    if (this.ExpandRowLevelFive == undefined || this.ExpandRowLevelFive != r) {
      this.ExpandRowLevelFive = r;
      this.GetData(5, parentId);
    } else {
      this.ExpandRowLevelFive = undefined;
    }

    this.ExpandRowLevelSix = undefined;
    this.ExpandRowLevelSeven = undefined;
    this.ExpandRowLevelEight = undefined;
  }
  ExpandLevelSix(f, parentId: number) {
    if (this.ExpandRowLevelSix == undefined || this.ExpandRowLevelSix != f) {
      this.ExpandRowLevelSix = f;
      this.GetData(6, parentId);
    } else {
      this.ExpandRowLevelSix = undefined;
    }

    this.ExpandRowLevelSeven = undefined;
    this.ExpandRowLevelEight = undefined;
  }
  ExpandLevelSeven(s, parentId: number) {
    if (
      this.ExpandRowLevelSeven == undefined ||
      this.ExpandRowLevelSeven != s
    ) {
      this.ExpandRowLevelSeven = s;
      this.GetData(7, parentId);
    } else {
      this.ExpandRowLevelSeven = undefined;
    }

    this.ExpandRowLevelEight = undefined;
  }
  ExpandLevelEight(v, parentId: number) {
    if (
      this.ExpandRowLevelEight == undefined ||
      this.ExpandRowLevelEight != v
    ) {
      this.ExpandRowLevelEight = v;
      this.GetData(8, parentId);
    } else {
      this.ExpandRowLevelEight = undefined;
    }
  }
  ExpandSubLevelAndEditLevel(level: number, i, item: AccountInfo) {
    this.AccountToSend = new AccountInfo();
    if (level == 2) {
      this.ExpandRowLevelTwo = i;
      this.AccountToSend.LevelNumber = 2;
    }
    if (level == 3) {
      this.ExpandRowLevelThree = i;
      this.AccountToSend.LevelNumber = 3;
    }
    if (level == 4) {
      this.ExpandRowLevelFour = i;
      this.AccountToSend.LevelNumber = 4;
    }
    if (level == 5) {
      this.ExpandRowLevelFive = i;
      this.AccountToSend.LevelNumber = 5;
    }
    if (level == 6) {
      this.ExpandRowLevelSix = i;
      this.AccountToSend.LevelNumber = 6;
    }
    if (level == 7) {
      this.ExpandRowLevelSeven = i;
      this.AccountToSend.LevelNumber = 7;
    }
    this.AccountToSend.Id = 0;
    this.AccountToSend.IsChild = true;
    this.AccountToSend.ParentId = item.Id;
    this.AccountToSend.IsActive = true;
    this.AccountToSend.AccountSetupId = null;
    this.AccountToSend.AccountTypeId = item.AccountTypeId;
    this.AccountToSend.AccountGroupId = item.AccountGroupId;
    this.AccountToSend.ParentNumber = item.AccountNo;
    this.AccountToSend.CostCenters = item.CostCenters;
    this.AccountToSend.AccountNo = '';
    this.AccountToSend.Code = item.AccountGroup.Code;
  }

  selectAccountId(inneritem) {
    if (
      (this.name != undefined && inneritem.IsChild != true) ||
      inneritem.IsChild == true
    ) {
      this.emitService.next(inneritem);
    } else {
      this.sharedService.ToastrError('لا يمكن إختيار حساب رئيسي ');
    }
    this.activeModal.close();
  }

  selectAccountId2(innerinneritem) {
    this.emitService.next(innerinneritem);
    this.activeModal.close();
  }
  selectAccountId3(inneritem4) {
    this.emitService.next(inneritem4);
    this.activeModal.close();
  }
  selectAccountId5(inneritem5) {
    this.emitService.next(inneritem5);
    this.activeModal.close();
  }
  selectAccountId6(inneritem6) {
    this.emitService.next(inneritem6);
    this.activeModal.close();
  }
  selectAccountId7(inneritem7) {
    this.emitService.next(inneritem7);
    this.activeModal.close();
  }
  selectAccountId8(inneritem8) {
    this.emitService.next(inneritem8);
    this.activeModal.close();
  }

  ExpandSubLevelAndEditLevelOpenModal(i, item: AccountInfo) {
    const modalRef = this.modalService.open(AddAccountComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.isNewAccount = true;

    modalRef.componentInstance.infoDataItem = item;
    // modalRef.componentInstance.levelNum = level;
    modalRef.componentInstance.supplierData = this.supplierData;
    modalRef.componentInstance.employeeData = this.employeeData;
    this.ExpandRowLevelTwo = i;
  }
}
